<template>
  <g fill="none">
    <g filter="url(#filter0_d_2083_6608)">
      <rect x="4" y="4" width="50" height="50" rx="8" fill="white" />
      <rect x="4.5" y="4.5" width="49" height="49" rx="7.5" stroke="#F0F3F6" />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41.7592 14.9826L25.1025 31.6392L24.8633 31.4C24.5894 31.1261 24.1409 31.1261 23.867 31.4L23.6428 31.6242C23.3689 31.8981 23.3689 32.3466 23.6428 32.6205L23.8821 32.8597L21.2932 35.4486C21.2677 34.316 20.8262 33.1926 19.9629 32.3292C18.183 30.5494 15.2983 30.5494 13.5184 32.3292C11.7386 34.1091 11.7386 36.9938 13.5184 38.7737C14.0362 39.2915 14.6476 39.6532 15.2971 39.8705C14.8036 39.9965 14.3355 40.2496 13.9495 40.6356C12.8019 41.7833 12.8019 43.6417 13.9484 44.7882C15.0949 45.9347 16.9533 45.9347 18.0998 44.7882C18.4859 44.4022 18.739 43.9341 18.8649 43.4406C19.0822 44.0901 19.444 44.7015 19.9617 45.2193C21.7416 46.9992 24.6264 46.9992 26.4062 45.2193C28.1861 43.4395 28.1861 40.5547 26.4062 38.7748C25.5429 37.9115 24.4183 37.4712 23.2868 37.4446L25.8757 34.8557L26.115 35.0949C26.3889 35.3688 26.8373 35.3688 27.1112 35.0949L27.3354 34.8707C27.6093 34.5968 27.6093 34.1484 27.3354 33.8745L27.0962 33.6352L35.4072 25.3242L36.4335 26.3505L37.4563 25.3277L38.9149 26.7862L37.8921 27.8091L38.9473 28.8643L41.0415 26.7701L38.7288 24.4574L39.8476 23.3386L42.1602 25.6513L43.3044 24.5071L40.9918 22.1944L42.1106 21.0757L44.4232 23.3883L46.5174 21.2941L45.5004 20.2771L44.4775 21.2999L43.019 19.8413L44.0418 18.8185L42.9774 17.7541L43.7529 16.9785C44.3019 16.4296 44.3019 15.5327 43.7529 14.9837C43.2039 14.4347 42.307 14.4347 41.758 14.9837L41.7592 14.9826ZM14.9019 33.715C15.9166 32.7002 17.5624 32.7002 18.5772 33.715C19.5919 34.7297 19.5919 36.3755 18.5772 37.3903C17.5624 38.405 15.9166 38.405 14.9019 37.3903C13.8871 36.3755 13.8871 34.7297 14.9019 33.715ZM17.2087 43.8971C16.5546 44.5513 15.4936 44.5513 14.8395 43.8971C14.1853 43.243 14.1853 42.182 14.8395 41.5278C15.4936 40.8737 16.5546 40.8737 17.2087 41.5278C17.8629 42.182 17.8629 43.243 17.2087 43.8971ZM25.0228 43.8359C24.008 44.8506 22.3622 44.8506 21.3475 43.8359C20.3327 42.8211 20.3327 41.1753 21.3475 40.1606C22.3622 39.1458 24.008 39.1458 25.0228 40.1606C26.0375 41.1753 26.0375 42.8211 25.0228 43.8359Z"
      fill="#FFCF06"
    />
    <mask
      id="mask0_2083_6608"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="12"
      y="14"
      width="35"
      height="33"
    >
      <path
        d="M41.7631 14.9787L25.1064 31.6353L24.8672 31.3961C24.5933 31.1222 24.1448 31.1222 23.8709 31.3961L23.6467 31.6203C23.3728 31.8942 23.3728 32.3427 23.6467 32.6166L23.886 32.8558L21.2971 35.4447C21.2716 34.3121 20.8302 33.1887 19.9668 32.3253C18.1869 30.5455 15.3022 30.5455 13.5223 32.3253C11.7425 34.1052 11.7425 36.9899 13.5223 38.7698C14.0401 39.2876 14.6515 39.6493 15.301 39.8666C14.8075 39.9926 14.3395 40.2457 13.9534 40.6317C12.8058 41.7794 12.8058 43.6378 13.9523 44.7843C15.0988 45.9308 16.9572 45.9308 18.1037 44.7843C18.4898 44.3983 18.7429 43.9302 18.8688 43.4367C19.0861 44.0862 19.4479 44.6976 19.9656 45.2154C21.7455 46.9953 24.6303 46.9953 26.4101 45.2154C28.19 43.4355 28.19 40.5508 26.4101 38.7709C25.5468 37.9076 24.4222 37.4673 23.2907 37.4407L25.8796 34.8518L26.1189 35.091C26.3928 35.3649 26.8412 35.3649 27.1151 35.091L27.3393 34.8668C27.6133 34.5929 27.6133 34.1445 27.3393 33.8706L27.1001 33.6313L35.4111 25.3203L36.4374 26.3466L37.4602 25.3238L38.9188 26.7823L37.896 27.8052L38.9512 28.8604L41.0454 26.7662L38.7327 24.4535L39.8515 23.3347L42.1642 25.6474L43.3083 24.5032L40.9957 22.1905L42.1145 21.0718L44.4271 23.3844L46.5213 21.2902L45.5043 20.2731L44.4814 21.296L43.0229 19.8374L44.0457 18.8146L42.9813 17.7501L43.7568 16.9746C44.3058 16.4257 44.3058 15.5288 43.7568 14.9798C43.2078 14.4308 42.3109 14.4308 41.762 14.9798L41.7631 14.9787ZM14.9058 33.7111C15.9205 32.6963 17.5663 32.6963 18.5811 33.7111C19.5958 34.7258 19.5958 36.3716 18.5811 37.3863C17.5663 38.4011 15.9205 38.4011 14.9058 37.3863C13.891 36.3716 13.891 34.7258 14.9058 33.7111ZM17.2127 43.8932C16.5585 44.5474 15.4975 44.5474 14.8434 43.8932C14.1892 43.2391 14.1892 42.1781 14.8434 41.5239C15.4975 40.8698 16.5585 40.8698 17.2127 41.5239C17.8668 42.1781 17.8668 43.2391 17.2127 43.8932ZM25.0267 43.832C24.0119 44.8467 22.3661 44.8467 21.3514 43.832C20.3366 42.8172 20.3366 41.1714 21.3514 40.1567C22.3661 39.1419 24.0119 39.1419 25.0267 40.1567C26.0414 41.1714 26.0414 42.8172 25.0267 43.832Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_2083_6608)">
      <path
        d="M44.281 15.4007L26.5645 33.1172L27.0938 33.6465L44.8103 15.93L44.281 15.4007Z"
        fill="#FFB000"
      />
      <path
        d="M42.82 13.9358L25.1035 31.6523L25.6328 32.1817L43.3494 14.4652L42.82 13.9358Z"
        fill="#FFC31F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.9052 34.8488L23.2989 37.455L22.2148 37.4805L25.3758 34.3195L25.9052 34.8488Z"
        fill="#FFB000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.8943 32.8577L21.2938 35.4581L21.2696 36.5411L24.4236 33.387L23.8943 32.8577Z"
        fill="#FFC31F"
      />
      <path
        d="M24.2934 30.8413L23.9629 31.1719L27.5688 34.7778L27.8994 34.4473L24.2934 30.8413Z"
        fill="#FFB000"
      />
      <path
        d="M23.4126 31.7202L23.082 32.0508L26.688 35.6567L27.0185 35.3262L23.4126 31.7202Z"
        fill="#FFC31F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.9327 44.7266C24.2291 46.4302 21.5246 46.5157 19.7436 44.9751C19.8153 45.0583 19.8892 45.1392 19.9678 45.2178C21.7373 46.9873 24.6174 46.9757 26.4007 45.1924C28.1841 43.4091 28.1956 40.529 26.4262 38.7595C26.3476 38.6809 26.2655 38.6058 26.1835 38.5353C27.7229 40.3175 27.6386 43.0208 25.935 44.7243L25.9327 44.7266Z"
        fill="#FFB000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.8245 44.6273C16.7612 45.6905 15.0727 45.7449 13.9609 44.7833C14.0059 44.8353 14.0522 44.8861 14.1007 44.9347C15.2056 46.0396 17.0028 46.0315 18.1158 44.9185C18.5214 44.5128 18.7803 44.0159 18.8913 43.4958C18.8323 43.3883 18.6347 43.015 18.6232 43.0751C18.5238 43.6414 18.2614 44.1881 17.8222 44.6273L17.8245 44.6273Z"
        fill="#FFB000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.3502 40.1568C20.3702 41.1369 20.3517 42.7249 21.2763 43.7881C21.2266 43.7454 21.178 43.7015 21.1306 43.6541C20.0708 42.5943 20.0431 40.9022 21.0694 39.8759C22.0957 38.8496 23.7877 38.8774 24.8475 39.9372C24.8949 39.9846 24.9388 40.0331 24.9816 40.0828C23.9172 39.1571 22.3303 39.1767 21.3502 40.1568Z"
        fill="#FFB000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.9537 33.7505C13.9737 34.7306 13.9552 36.3186 14.8798 37.3819C14.8301 37.3391 14.7815 37.2952 14.7342 37.2478C13.6743 36.188 13.6466 34.496 14.6729 33.4697C15.6992 32.4434 17.3912 32.4711 18.451 33.5309C18.4984 33.5783 18.5424 33.6269 18.5851 33.6766C17.5207 32.7508 15.9338 32.7704 14.9537 33.7505Z"
        fill="#FFB000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.8865 41.5486C14.252 42.1831 14.2393 43.2106 14.838 43.8994C14.8056 43.8717 14.7744 43.8428 14.7444 43.8127C14.0579 43.1262 14.0405 42.0317 14.7051 41.3672C15.3696 40.7026 16.4641 40.72 17.1507 41.4065C17.1807 41.4365 17.2108 41.4689 17.2373 41.5001C16.5485 40.9014 15.5222 40.913 14.8865 41.5486Z"
        fill="#FFB000"
      />
      <path
        d="M35.8228 24.9116L35.4102 25.3242L38.9491 28.8631L39.3617 28.4505L35.8228 24.9116Z"
        fill="#FFC31F"
      />
      <path
        d="M46.2022 20.8427L38.9707 28.0742L39.5 28.6036L46.7316 21.372L46.2022 20.8427Z"
        fill="#FFB000"
      />
    </g>
    <path
      d="M19.264 33.5945L18.5648 33.2004C18.0771 32.9253 17.4807 32.9253 16.993 33.2004L16.2937 33.5945L16.6878 32.8953C16.9629 32.4076 16.9629 31.8112 16.6878 31.3235L16.2937 30.6242L16.993 31.0183C17.4807 31.2934 18.0771 31.2934 18.5648 31.0183L19.264 30.6242L18.8872 31.4309C18.6873 31.8597 18.6861 32.3555 18.8872 32.7855L19.264 33.5922L19.264 33.5945Z"
      fill="#FFE539"
    />
    <g style="mix-blend-mode:overlay">
      <path
        d="M18.4271 32.7589L18.1208 32.5867C17.9082 32.4665 17.647 32.4665 17.4343 32.5867L17.128 32.7589L17.3003 32.4526C17.4205 32.24 17.4205 31.9788 17.3003 31.7661L17.128 31.4598L17.4343 31.632C17.647 31.7522 17.9082 31.7522 18.1208 31.632L18.4271 31.4598L18.2618 31.8123C18.174 31.9996 18.174 32.2169 18.2618 32.4041L18.4271 32.7566L18.4271 32.7589Z"
        fill="#FFE539"
      />
    </g>
    <path
      d="M19.2757 41.8172L18.5765 41.4231C18.0888 41.148 17.4924 41.148 17.0047 41.4231L16.3055 41.8172L16.6996 41.1179C16.9746 40.6302 16.9746 40.0338 16.6996 39.5461L16.3055 38.8469L17.0047 39.241C17.4924 39.5161 18.0888 39.5161 18.5765 39.241L19.2757 38.8469L18.899 39.6536C18.699 40.0824 18.6979 40.5782 18.899 41.0081L19.2757 41.8149L19.2757 41.8172Z"
      fill="#FFE539"
    />
    <g style="mix-blend-mode:overlay">
      <path
        d="M18.4408 40.9816L18.1345 40.8094C17.9219 40.6892 17.6607 40.6892 17.448 40.8094L17.1417 40.9816L17.3139 40.6753C17.4341 40.4626 17.4341 40.2014 17.3139 39.9888L17.1417 39.6825L17.448 39.8547C17.6607 39.9749 17.9219 39.9749 18.1345 39.8547L18.4408 39.6825L18.2755 40.035C18.1877 40.2222 18.1877 40.4395 18.2755 40.6267L18.4408 40.9793L18.4408 40.9816Z"
        fill="#FFE539"
      />
    </g>
    <path
      d="M26.4535 41.868L25.7542 41.4738C25.2665 41.1988 24.6701 41.1988 24.1824 41.4738L23.4832 41.868L23.8773 41.1687C24.1524 40.681 24.1524 40.0846 23.8773 39.5969L23.4832 38.8977L24.1824 39.2918C24.6701 39.5669 25.2665 39.5669 25.7542 39.2918L26.4535 38.8977L26.0767 39.7044C25.8767 40.1332 25.8756 40.629 26.0767 41.0589L26.4535 41.8656L26.4535 41.868Z"
      fill="#FFE539"
    />
    <g style="mix-blend-mode:overlay">
      <path
        d="M25.6166 41.0323L25.3103 40.8601C25.0976 40.7399 24.8364 40.7399 24.6238 40.8601L24.3175 41.0323L24.4897 40.7261C24.6099 40.5134 24.6099 40.2522 24.4897 40.0396L24.3175 39.7333L24.6238 39.9055C24.8364 40.0257 25.0976 40.0257 25.3103 39.9055L25.6166 39.7333L25.4513 40.0858C25.3635 40.273 25.3635 40.4903 25.4513 40.6775L25.6166 41.03V41.0323Z"
        fill="#FFE539"
      />
    </g>
    <path
      opacity="0.6"
      d="M20.6958 20.6241L18.3416 22.2932L18.0761 25.1668L16.4071 22.8125L13.5335 22.5471L15.8877 20.878L16.1532 18.0044L17.8222 20.3587L20.6958 20.6241Z"
      fill="#FEE20A"
    />
    <path
      opacity="0.6"
      d="M37.2888 42.292L36.0029 43.2036L35.8579 44.7732L34.9463 43.4873L33.3767 43.3423L34.6626 42.4307L34.8076 40.8611L35.7192 42.147L37.2888 42.292Z"
      fill="#FEE20A"
    />
    <path
      opacity="0.4"
      d="M38.6121 29.5666L37.821 30.1275L37.7318 31.0931L37.171 30.302L36.2054 30.2128L36.9965 29.652L37.0857 28.6864L37.6465 29.4774L38.6121 29.5666Z"
      fill="#FEE20A"
    />
    <path
      opacity="0.4"
      d="M35.4471 14.5866L34.381 15.3425L34.2607 16.6438L33.5049 15.5777L32.2035 15.4575L33.2697 14.7016L33.3899 13.4003L34.1458 14.4664L35.4471 14.5866Z"
      fill="#FEE20A"
    />
    <defs>
      <filter
        id="filter0_d_2083_6608"
        x="0"
        y="0"
        width="58"
        height="58"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2083_6608" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2083_6608"
          result="shape"
        />
      </filter>
    </defs>
  </g>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
